// extracted by mini-css-extract-plugin
export var icon = "_x5-0";